import React, { useState, useEffect } from "react";
import ClearIcon from "@mui/icons-material/Clear";
import i18next from "i18next";
import feedbackService from "../../api/feedbackService";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Select,
  MenuItem,
  TextField,
  Snackbar,
  Alert,
} from "@mui/material";

const FeedbackComponent = ({ onFeedbackSubmit, ContestoApp, ...props }) => {
  const { t } = i18next;
  const [fArgumentType, setfArgumentType] = useState("");
  const [fDescrText, setfDescrText] = useState("");
  const [apiData, setApiData] = useState([]);
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  // Aggiunta dei nuovi stati per errori
  const [errorArgument, setErrorArgument] = useState(false);
  const [errorDescription, setErrorDescription] = useState(false);

  // Aggiunta di stati per Snackbar
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("info");

  useEffect(() => {
    feedbackService.getArgumentList(ContestoApp).then((res) => {
      setApiData(
        res.data.map((item) => {
          return { ...item, label: t(item.fArgument) };
        })
      );
    });
  }, [ContestoApp, t]);

  const handleFeedbackTypeChange = (event) => {
    setfArgumentType(event.target.value);
  };

  const handleFeedbackTextChange = (event) => {
    setfDescrText(event.target.value);
  };

  const handleSubmit = () => {
    const feedbackDetail = {
      fArgument: fArgumentType,
      fDescr: fDescrText,
    };

    feedbackService
      .addFeedback(feedbackDetail)
      .then((response) => {
        props.onSubmit(response.data);
        onFeedbackSubmit(response.data);
        props.onClose();
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        props.onClose(); // Chiudi il Dialog indipendentemente dal risultato della richiesta
      });
  };

  const validateAndSubmit = () => {
    let isValid = true;

    // Validazione dell'argomento
    if (!fArgumentType) {
      setErrorArgument(true);
      isValid = false;
    } else {
      setErrorArgument(false);
    }

    // Validazione della descrizione
    if (!fDescrText) {
      setErrorDescription(true);
      isValid = false;
    } else {
      setErrorDescription(false);
    }

    if (isValid) {
      handleSubmit();
    } else {
      // Configurare il messaggio di Snackbar per errore
      setSnackbarMessage("Compilare tutti i campi richiesti");
      setSnackbarSeverity("error");
      setOpenSnackbar(true);
    }
  };

  return (
    <>
      <Dialog
        classes={{ paper: "custom-dialog-paper" }}
        className="custom-dialog"
        open={props.open}
        onClose={props.onClose}>
        <DialogActions className="custom-dialog-actions">
          <Button tabIndex={0} onClick={props.onClose} color="secondary">
            <ClearIcon />
          </Button>
        </DialogActions>
        <DialogTitle className="custom-dialog-title">
          {t("uman.feedback.title")}
        </DialogTitle>
        <DialogContent>
          <Select
            value={fArgumentType}
            onChange={handleFeedbackTypeChange}
            fullWidth
            displayEmpty
            inputProps={{ "aria-label": "Argomento" }}
            error={errorArgument}>
            <MenuItem value="" disabled>
              {t("uman.feedback.feedback_type")}
            </MenuItem>
            {apiData.map((item, index) => (
              <MenuItem key={index} value={item.fArgument}>
                {item.label}
              </MenuItem>
            ))}
          </Select>
          <TextField
            multiline
            rows={4}
            value={fDescrText}
            onChange={handleFeedbackTextChange}
            fullWidth
            label={t("uman.feedback.feedback_description")}
            margin="normal"
            error={errorDescription}
            helperText={
              errorDescription ? t("uman.feedback.description_requered") : ""
            }
          />
        </DialogContent>
        <DialogActions>
          <Button
            tabIndex={0}
            className="submit-send"
            onClick={validateAndSubmit}
            color="primary">
            {t("uman.feedback.send")}
          </Button>
        </DialogActions>
      </Dialog>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={2000}
        onClose={() => setOpenSnackbar(false)}>
        <Alert
          onClose={() => setOpenSnackbar(false)}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </>
  );
};

export default FeedbackComponent;
